import { createRouter, createWebHistory } from 'vue-router';

import EmployeesList from '@/components/EmployeesList.vue';
import NotFound from '@/components/NotFound.vue';
import HomePage from '@/components/HomePage.vue';
import RegisterForm from '@/components/Register/RegisterForm.vue';
import LoginForm from '@/components/Login/LoginForm.vue';
import TasksList from '@/components/Tasks/TasksList.vue';
import MyTasks from '@/components/Tasks/MyTasks.vue';
import TaskInfo from '@/components/Tasks/TaskInfo.vue';

const routes = [
    {
        path: '/', 
        component: HomePage
    },
    {   path: '/employees', 
      component: EmployeesList
    },
    {   path: '/register', 
      component: RegisterForm
    },
    {   path: '/login', 
      component: LoginForm
    },
    {
      path: '/taskinfo/:id',
      name: 'TaskInfo',
      component: TaskInfo,
      props: true // Esto permite pasar los parámetros de la URL como props al componente
    },
    {
        path: '/tasks',
        component: TasksList
    },
    {
      path:'/mytasks',
      component: MyTasks
    },
    { path: '/:pathMatch(.*)', 
      component: NotFound 
    }

];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
